import React from 'react';
import Footer from '../../components/Footer/Footer';

const Privacy = () => {
	return (
		<div className="bg-ofg-light-green">
			<div className="container mx-auto leading-6 px-7 py-28 font-redhat text-ofg-light-tan">
				<h1 className="mb-10 text-6xl font-light">
					One Fang Digital <br />
					<span className="font-extrabold">Privacy Policy</span>
				</h1>
				<p className="w-full mb-5 xl:max-w-1/2">Last Updated: 7th Feb 2024</p>
				<p className="w-full mb-5 xl:max-w-1/2">
					Welcome to One Fang Digital! At One Fang Digital, we are committed to
					protecting and respecting your privacy. This Privacy Policy outlines
					how we collect, use, disclose, and protect your personal information.
					By using our website, products, or services, you agree to the terms of
					this Privacy Policy.
				</p>
				<h2 className="mb-5 text-3xl font-bold">1. Information We Collect</h2>
				<h3 className="mb-4 text-xl">1.1 Personal Information</h3>
				<p className="w-full mb-5 xl:max-w-1/2">
					We may collect and process the following personal information:
				</p>
				<ul className="w-full mb-5 list-disc xl:max-w-1/2">
					<li>Name Contact details (email address, phone number)</li>
					<li>Company name (if applicable) </li>
					<li>Billing information </li>
					<li>User preferences and settings IP address</li>
					<li>Device information</li>
				</ul>
				<h3 className="mb-4 text-xl">1.2 Non-Personal Information</h3>
				<p className="w-full mb-5 xl:max-w-1/2">
					We may also collect non-personal information, such as aggregated data,
					which cannot be used to identify individuals.
				</p>
				<h2 className="mb-5 text-3xl font-bold">
					2. How We Use Your Information
				</h2>
				<p className="w-full mb-5 xl:max-w-1/2">
					We use your information for the following purposes:
				</p>
				<ul className="w-full mb-5 list-disc xl:max-w-1/2">
					<li>To provide and maintain our services </li>
					<li>To process transactions and billing</li>
					<li>To communicate with you about our products and services </li>
					<li>To improve our products and services </li>
					<li>To personalize your experience </li>
					<li>To comply with legal obligations</li>
				</ul>
				<h2 className="mb-5 text-3xl font-bold">
					3. How We Protect Your Information
				</h2>
				<p className="w-full mb-5 xl:max-w-1/2">
					We implement security measures to safeguard your personal information:
				</p>
				<p className="w-full mb-5 xl:max-w-1/2">
					Secure Sockets Layer (SSL) technology for data transmission Regular
					monitoring and testing of our systems Restricted access to personal
					information Encryption of sensitive information
				</p>
				<h2 className="mb-5 text-3xl font-bold">4. Sharing Your Information</h2>
				<p className="w-full mb-5 xl:max-w-1/2">
					We do not sell, trade, or rent your personal information to third
					parties. However, we may share your information in the following
					situations:
				</p>
				<ul className="w-full mb-5 list-disc xl:max-w-1/2">
					<li>With your consent </li>
					<li>To comply with legal obligations </li>
					<li>To protect our rights and property </li>
					<li>In the event of a business transfer or acquisition</li>
				</ul>
				<h2 className="mb-5 text-3xl font-bold">
					5. Cookies and Tracking Technologies
				</h2>
				<p className="w-full mb-5 xl:max-w-1/2">
					We use cookies and similar technologies to enhance your experience on
					our website. You can manage your cookie preferences through your
					browser settings.
				</p>
				<h2 className="mb-5 text-3xl font-bold">6. Your Rights</h2>
				<p className="w-full mb-5 xl:max-w-1/2">You have the right to:</p>
				<ul className="w-full mb-5 list-disc xl:max-w-1/2">
					<li>Access, correct, or delete your personal information </li>
					<li>Object to processing or request restriction</li>
					<li>Data portability </li>
					<li>Withdraw consent (where applicable)</li>
				</ul>
				<h2 className="mb-5 text-3xl font-bold">7. Children's Privacy</h2>
				<p className="w-full mb-5 xl:max-w-1/2">
					Our services are not intended for individuals under the age of 13. We
					do not knowingly collect personal information from children.
				</p>
				<h2 className="mb-5 text-3xl font-bold">
					8. Changes to This Privacy Policy
				</h2>
				<p className="w-full mb-5 xl:max-w-1/2">
					We may update this Privacy Policy from time to time. Any changes will
					be posted on our website with the effective date.
				</p>
				<h2 className="mb-5 text-3xl font-bold">9. Contact Us</h2>
				<p className="w-full mb-5 xl:max-w-1/2">
					If you have any questions, concerns, or requests regarding your
					privacy or this Privacy Policy, please contact us at
					[hello@onefangdigital.com].
				</p>
				<p className="w-full xl:max-w-1/2">
					Thank you for trusting One Fang Digital with your information. <br />
					One Fang Digital.
				</p>
			</div>
		</div>
	);
};

export default Privacy;
